import React from 'react'
import { SvgIcon } from '@material-ui/core'

function ListViewIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        id='Vector'
        d='M5 6.5C5 6.23478 5.10536 5.98043 5.29289 5.79289C5.48043 5.60536 5.73478 5.5 6 5.5H18C18.2652 5.5 18.5196 5.60536 18.7071 5.79289C18.8946 5.98043 19 6.23478 19 6.5V7.5C19 7.76522 18.8946 8.01957 18.7071 8.20711C18.5196 8.39464 18.2652 8.5 18 8.5H12H6C5.73478 8.5 5.48043 8.39464 5.29289 8.20711C5.10536 8.01957 5 7.76522 5 7.5V6.5ZM5 11.5C5 11.2348 5.10536 10.9804 5.29289 10.7929C5.48043 10.6054 5.73478 10.5 6 10.5H18C18.2652 10.5 18.5196 10.6054 18.7071 10.7929C18.8946 10.9804 19 11.2348 19 11.5V12.5C19 12.7652 18.8946 13.0196 18.7071 13.2071C18.5196 13.3946 18.2652 13.5 18 13.5H6C5.73478 13.5 5.48043 13.3946 5.29289 13.2071C5.10536 13.0196 5 12.7652 5 12.5V11.5ZM5 16.5C5 16.2348 5.10536 15.9804 5.29289 15.7929C5.48043 15.6054 5.73478 15.5 6 15.5H18C18.2652 15.5 18.5196 15.6054 18.7071 15.7929C18.8946 15.9804 19 16.2348 19 16.5V17.5C19 17.7652 18.8946 18.0196 18.7071 18.2071C18.5196 18.3946 18.2652 18.5 18 18.5H6C5.73478 18.5 5.48043 18.3946 5.29289 18.2071C5.10536 18.0196 5 17.7652 5 17.5V16.5Z'
      />
    </SvgIcon>
  )
}

export default ListViewIcon
